import { rqtGetWorkFlowNodeDefinition, rqtPostTrace } from '@/services/common/workflow';
export default {
  components: {},
  props: {
    workFlowDefinitionId: {
      required: true
    },
    businessId: {
      required: true
    }
  },
  data() {
    return {
      nodeDefinitions: [],
      detailNodes: [],
      isCompleted: false
    };
  },
  computed: {
    hActive() {
      if (this.detailNodes.length == 0) {
        return -1;
      }
      if (this.isCompleted) {
        return this.nodeDefinitions.length;
      }
      const lastNode = this.detailNodes[this.detailNodes.length - 1];
      for (let i = 0; i < this.nodeDefinitions.length; i++) {
        if (this.nodeDefinitions[i].id == lastNode.nodeDefinitionId) {
          if (lastNode.status == '2') {
            return i + 1;
          } else {
            return i;
          }
        }
      }
      return -1;
    },
    vActive() {
      if (this.detailNodes.length == 0) {
        return -1;
      }
      const lastNode = this.detailNodes[this.detailNodes.length - 1];
      if (lastNode.status == '2') {
        return this.detailNodes.length;
      } else {
        return this.detailNodes.length - 1;
      }
    }
  },
  async mounted() {
    let res = await rqtGetWorkFlowNodeDefinition(this.workFlowDefinitionId);
    this.nodeDefinitions = res.data.data;
    this.nodeDefinitions.sort(function (a, b) {
      return a.nodeIndex - b.nodeIndex;
    });
    const finishNodeDefinition = this.nodeDefinitions.find(e => e.type == '0');
    this.nodeDefinitions = this.nodeDefinitions.filter(e => e.type != '0');
    let params = {
      workFlowDefinitionId: this.workFlowDefinitionId,
      businessId: this.businessId
    };
    res = await rqtPostTrace(params);
    this.detailNodes = res.data.data;
    const finishNode = this.detailNodes.find(e => e.nodeDefinitionId == finishNodeDefinition.id);
    if (finishNode) {
      this.isCompleted = true;
    }
  },
  methods: {}
};